module.exports = __webpack_public_path__ + "img/ic-cullen.5af37b90.jpg";